import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Textarea, Btn } from "@/components/UI";
import { MATERIAL_TYPES, EMPTY_MATERIAL } from "@/lib/materials";
import { apiError } from "@/lib/customers";

// Ürün Detayı → Ambalaj & Malzemeler master düzenleme (stok yalnız oluştururken başlangıç değeri).
export function MaterialFormModal({ open, productId, material, suppliers, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY_MATERIAL);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setF(material ? { ...EMPTY_MATERIAL, ...material, default_supplier_id: material.default_supplier_id || "" } : EMPTY_MATERIAL); setErr(""); } }, [open, material]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const save = async () => {
    if (!f.name.trim()) return setErr("Malzeme adı zorunlu");
    if (!(Number(f.usage_qty) > 0)) return setErr("Kullanım miktarı 0'dan büyük olmalı");
    setBusy(true); setErr("");
    const body = { ...f, usage_qty: Number(f.usage_qty), stock_qty: Number(f.stock_qty) || 0, critical_stock: Number(f.critical_stock) || 0,
      default_supplier_id: f.default_supplier_id || null, default_supplier_name: suppliers.find((s) => s.id === f.default_supplier_id)?.name || null };
    try {
      const r = material ? await api.put(`/product-materials/${material.id}`, body) : await api.post(`/products/${productId}/materials`, body);
      onSaved(r);
    } catch (e) { setErr(apiError(e, "Kaydedilemedi")); } finally { setBusy(false); }
  };
  return (
    <Modal open={open} onClose={onClose} title={material ? "Malzemeyi Düzenle" : "Malzeme Ekle"}>
      <div className="grid grid-cols-2 gap-3" data-testid="material-form">
        <div className="col-span-2"><Input label="Malzeme Adı *" value={f.name} onChange={set("name")} data-testid="material-form-name" /></div>
        <Select label="Malzeme Türü" value={f.material_type} onChange={set("material_type")} data-testid="material-form-type">
          {MATERIAL_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </Select>
        <Input label="Birim" value={f.unit} onChange={set("unit")} data-testid="material-form-unit" />
        <Input label="1 Ürün İçin Kullanım" type="number" min="0" step="any" value={f.usage_qty} onChange={set("usage_qty")} data-testid="material-form-usage" />
        {!material && <Input label="Başlangıç Stok" type="number" step="any" value={f.stock_qty} onChange={set("stock_qty")} data-testid="material-form-stock" />}
        <Input label="Kritik Stok" type="number" min="0" step="any" value={f.critical_stock} onChange={set("critical_stock")} data-testid="material-form-critical" />
        <Select label="Varsayılan Tedarikçi" value={f.default_supplier_id} onChange={set("default_supplier_id")} data-testid="material-form-supplier">
          <option value="">— Yok —</option>{suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </Select>
        <div className="col-span-2"><Textarea label="Not" value={f.note || ""} onChange={set("note")} data-testid="material-form-note" /></div>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!f.active} onChange={set("active")} data-testid="material-form-active" /> Aktif</label>
        {err && <div className="col-span-2 text-xs text-rose-600" data-testid="material-form-error">{err}</div>}
        <div className="col-span-2 flex justify-end gap-2">
          <Btn variant="secondary" onClick={onClose} data-testid="material-form-cancel">Vazgeç</Btn>
          <Btn onClick={save} disabled={busy} data-testid="material-form-save">{busy ? "Kaydediliyor…" : "Kaydet"}</Btn>
        </div>
      </div>
    </Modal>
  );
}
